// extracted by mini-css-extract-plugin
export default {"wrapper":"DailySurvey_wrapper__8RXS2"};